module.exports = __webpack_public_path__ + "static/media/intelligent_icon.fbcdb3ff.png";